export const buttonStyles = {
  borderRadius: 0,
  fontSize: 16,
  height: 48,
  padding: '2px 0 0',
  width: '100%',
};

export const toolBarStyles = theme => ({
  [theme.breakpoints.up('sm')]: {
    top: 64,
  },
  backgroundColor: theme.palette.surface.white,
  boxShadow: theme.shadows[1],
  color: theme.palette.secondary.main,
  display: 'flex',
  minHeight: 48,
  position: 'sticky',
  top: 55,
  width: '100%',
  zIndex: 4,
});

export const toolbarTabsStyles = theme => ({
  flex: '0 0 50%',
  justifyContent: 'center',
  [theme.breakpoints.up('sm')]: {
    minHeight: 48,
  },
});
